import {useDebugValue} from 'react';

import {useTranslations} from './';

const defaultTranslations = {
    clearSearchLabel: 'Clear Search',
    noResultsFoundMessage: 'No results found',
    placeholderMessage: 'Where to?',
    recentSearchesMessage: 'Your recent searches',
    recentlyViewedLabel: 'Recently Viewed',
    resultsFoundMessage: '{NUM_RESULTS} results. Use the up and down keys to navigate.',
    selectedMessage: 'Destination selected: {DESTINATION}',
    trendingDestinationsMessage: 'Trending destinations today',
    typeAirportLabel: 'Airport',
    typeCityLabel: 'City',
    typeLandmarkLabel: 'Landmark',
    typeMetroStationLabel: 'Metro Station',
    typeNeighborhoodLabel: 'Neighborhood',
    typePropertyLabel: 'Property',
    typeRegionLabel: 'Region',
    typeTrainStationLabel: 'Train Station',
    whereLabel: 'Where'
};

function useDestinationTranslations(props) {
    const {
        destinationTranslations: propsTranslations
    } = props;

    const {
        translations
    } = useTranslations(defaultTranslations, propsTranslations);

    const result = {
        translations
    };

    useDebugValue(result);

    return result;
}

export {useDestinationTranslations};
